import { Button, Center, EmptyState, Table } from '@mantine/core';
import { IconPlus, IconVariable } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadCustomVariables } from '~/modules/Settings/Variables/CustomVariables/api';

import { CustomVariablesItem } from './CustomVariablesItem';

type Props = {
  onCreate: () => void;
  actionLabel: string;
  isActive: boolean;
};

export const CustomVariables = ({ onCreate, actionLabel, isActive }: Props) => {
  const { t } = useTranslation();

  const { customVariables, isCustomVariablesInitialLoading } = useLoadCustomVariables();

  if (customVariables.data.length === 0 && !isCustomVariablesInitialLoading) {
    return (
      <Center my="xl" w="100%">
        <EmptyState
          icon={<IconVariable size={48} stroke={1.5} />}
          title={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.CUSTOM_VARIABLES_TITLE)}
          description={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.CUSTOM_VARIABLES_DESCRIPTION)}
        >
          <EmptyState.Actions>
            <Button
              disabled={!isActive}
              rightSection={<IconPlus size={20} stroke={1.5} />}
              onClick={() => isActive && onCreate()}
            >
              {actionLabel}
            </Button>
          </EmptyState.Actions>
        </EmptyState>
      </Center>
    );
  }

  return (
    <Table verticalSpacing="xs" striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>{t(i18nKeys.SETTINGS.CUSTOM_VARIABLES.NAME)}</Table.Th>
          <Table.Th>{t(i18nKeys.SETTINGS.CUSTOM_VARIABLES.COLUMN_NAME)}</Table.Th>
          <Table.Th>{t(i18nKeys.SETTINGS.CUSTOM_VARIABLES.VAR_TYPE)}</Table.Th>
          <Table.Th>{t(i18nKeys.SETTINGS.CUSTOM_VARIABLES.MODEL_TYPE)}</Table.Th>
          <Table.Th>{t(i18nKeys.SETTINGS.CUSTOM_VARIABLES.DEFAULT_VALUE)}</Table.Th>
          <Table.Th w={100}>{t(i18nKeys.FORM.ACTIONS)}</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {customVariables.data.map(item => (
          <CustomVariablesItem key={item.id} item={item} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
